<template>
  <div class="conf-wrp">
    <div class="content-wrp">
      <div class="content">
        <el-form class="form" :model="value" :rules="rules" ref="form" label-width="20%">
          <section>
            <div class="title">
              <span>基础设置</span>
            </div>
            <div class="conf">
              <el-form-item label="图片设置：" prop="baseDetailImageAutoFillConfig">
                <el-checkbox v-model="value.baseDetailImageAutoFillConfig">基础资料商品详情图填充至咸鱼商品图片</el-checkbox>
              </el-form-item>
            </div>
          </section>
          <section>
            <div class="title">
              <span>发货地址</span>
            </div>
            <div class="conf">
              <el-form-item label="发货地址：" prop="xyShopAddress">
                <el-select-address ref="addressRef" :widths="['120px', '104px', '104px', -1]" v-model="value.xyShopAddress" />
              </el-form-item>
            </div>
          </section>
          <section>
            <div class="title">
              <span>上架设置</span>
            </div>
            <div class="conf">
              <el-form-item label="上架设置:" prop="shelfState">
                <el-radio-group v-model="value.shelfState">
                  <el-radio :label="1">立即上架</el-radio>
                  <el-radio :label="3">放入草稿箱</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </section>
          <PriceConf ref="PriceConfRef" platform="xy" :priceList="value.price" :shopPriceConf="value.shopPriceConf"></PriceConf>
          <div class="btns">
            <el-button type="primary" @click="save">保存模板</el-button>
            <el-button @click="back">返回</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/prod.scss';
import { getDistributionConfig, updateDistributionConfig, getYouZanTemplates } from '@servers/prod/conf/index.js';
import PriceConf from './components/PriceConf.vue';

const PLATFORMID = 'xy';

export default {
  name: 'XyConf',
  props: {
    back: Function,
  },
  components: {
    PriceConf,
  },
  data() {
    return {
      shopList: [],
      value: {
        shelfState: 3,
        price: [],
        shopPriceConf: [],
        baseDetailImageAutoFillConfig: false
      },
      rules: {
        shelfState: [{ required: true, message: '' }],
      },
    };
  },
  mounted() {
    this.getConf();
  },
  methods: {
    async getConf() {
      const res = await getDistributionConfig({ shopType: PLATFORMID });
      const shopList = this.$store.getters.get_AllShops_BySource('xy');
      this.shopList = shopList;
      if (res) {
        const { xianYuBaseConfig } = res;
        let baseDetailImageAutoFillConfig = true
        // 判断 xianYuBaseConfig 是否存在 imageConfig 属性
        if (xianYuBaseConfig && xianYuBaseConfig.imageConfig) {
          // 判断 imageConfig 是否存在 baseDetailImageAutoFillConfig 属性
          if (xianYuBaseConfig.imageConfig.baseDetailImageAutoFillConfig) {
            // 存在 baseDetailImageAutoFillConfig 属性的处理逻辑
            if (xianYuBaseConfig.imageConfig.baseDetailImageAutoFillConfig === '1') {
              baseDetailImageAutoFillConfig = true;
            } else {
              baseDetailImageAutoFillConfig = false;
            }
          }
        }
        
        const value = {
          shelfState: res.shelfState || this.value.shelfState,
          price: res.price ? JSON.parse(res.price) : [],
          shopPriceConf: res.shopPriceConf ? JSON.parse(res.shopPriceConf) : [],
          xyShopAddress: (res.xyShopAddress || '').split(','),
          baseDetailImageAutoFillConfig,
        };
        this.$set(this, 'value', value);
      }
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { shelfState } = this.value;
          let [commConf, shopConf] = this.$refs.PriceConfRef.getData();
          const { addressRef } = this.$refs;
          const shopAddressList = [addressRef.province, addressRef.city, addressRef.area];
          const res = await updateDistributionConfig({
            shopType: PLATFORMID,
            shelfState,
            price: JSON.stringify(commConf),
            shopPriceConf: JSON.stringify(shopConf),
            xyShopAddress: shopAddressList.join(','),
            baseConfig: JSON.stringify({
              imageConfig: {
                baseDetailImageAutoFillConfig: this.value.baseDetailImageAutoFillConfig ? '1' : '0',
              }
            })
          });
          if (res) {
            this.$message.success('保存成功');
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
</style>